<div class="listing-content-section">
  <p class="listing-description">{{ listing?.description }}</p>
  <div class="listing-icon-grid">
    <div class="icon-wrapper" *ngFor="let landType of listing?.landTypes">
      <div class="icon-inner-wrapper">
        <div class="icon-bullet">
          <curbnturf-site-svgs [type]="landType"> </curbnturf-site-svgs>
        </div>
        <div class="rift-soft-copy">{{ terrainName(landType) }}</div>
      </div>
    </div>
  </div>
</div>
